import React from 'react';
import { formatDisplayDate } from '../../utils/time';

const WinningPremiumCouponCard = ({ coupon }) => (
  <article className="winning-archive-card winning-coupon-card premium-winning-coupon-card">
    <div className="winning-archive-top">
      <span className="hero-badge">Tutan Premium Kupon</span>
      <span className="confidence high">%{coupon.confidenceScore || 0}</span>
    </div>

    <div className="analysis-subheader">
      <span className="analysis-datetime">{formatDisplayDate(coupon.playedDate || coupon.couponDate)}</span>
    </div>

    <h3>{coupon.title}</h3>
    <p className="analysis-summary">
      {formatDisplayDate(coupon.playedDate || coupon.couponDate)} tarihinde oynanan premium kuponun tum secimleri basarili oldu.
    </p>

    <div className="winning-coupon-items">
      {(coupon.items || []).map((item, index) => (
        <div key={`${coupon.id}-${index}`} className="winning-coupon-item">
          <div className="winning-coupon-hit-row">
            <span className="winning-check">OK</span>
            <strong>{item.selection}</strong>
          </div>
          <span>
            {item.match?.homeTeam?.name} - {item.match?.awayTeam?.name}
          </span>
          {item.outcome?.label ? <span>{item.outcome.label}: {item.outcome.value}</span> : null}
        </div>
      ))}
    </div>
  </article>
);

export default WinningPremiumCouponCard;
